/*
**検査3解答
** 9ページ
*/
const answer={
    1:"て",
    2:"ほ",
    3:"さ",
    4:"ひ",
    5:"ふ",
    6:"の",
    
    7:"ま",
    8:"み",
    9:"よ",
    10:"そ",
    11:"な",
    12:"こ",
    
    13:"せ",
    14:"あ",
    15:"お",
    16:"つ",
    17:"に",
    18:"え",
    
    19:"ろ",
    20:"ち",
    21:"た",
    22:"む",
    23:"す",
    24:"も",
    
    25:"は",
    26:"へ",
    27:"い",
    28:"け",
    29:"と",
    30:"や",
    
    31:"か",
    32:"ゆ",
    33:"ら",
    34:"め",
    35:"き",
    36:"わ",
    };

    export default answer;